import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import VendorInvoiceComponent from "./VendorInvoiceComponent";
import Uri from "../../Network/Uri";
import {
  ADD_VENDOR_INVOICE,
  GET_VENDOR_INVOICES,
  UPDATE_VENDOR_INVOICE,
  DELETE_VENDOR_INVOICE,
  GET_VENDORS,
  GET_PAYMENTS,
  UPDATE_INVOICE_BILL_IMAGE,
} from "../../Network/ApiPaths";
import postClientDataResponse from "../../Network/PostClientDataResponse";
import getResponseClient from "../../Network/GetClientDataResponse";


let storeFresh;
let clientHost;

class VendorInvoiceContainer extends React.Component {
  constructor(props) {
    super();
    const client = window.localStorage.getItem("clientAccess");
    storeFresh = JSON.parse(client);
    if (storeFresh !== null) {
      clientHost = storeFresh.host;
    }
    this.state = {
      invoices: [],
      vendors: [],
      payments: [],
      selectedVendor: "",
      invoiceDate: "",
      invoiceAmount: "",
      status: "NOTPAID",
      invoiceFile: null,
      filterVendorId: "",
      filterFromDate: "",
      filterToDate: "",
      filterStatus: "",
    };
  }

  componentDidMount() {
    this.getInvoices();
    this.getVendors();
    this.getPayments();
  }
  componentDidUpdate(prevProps) {
    if (!prevProps.active && this.props.active) {
      this.getInvoices();
      this.getVendors();
    }
  }
  onInvoiceFileChange = (e) => this.setState({ invoiceFile: e.target.files[0] });
  onVendorChange = (e) => this.setState({ selectedVendor: e.target.value });
  onInvoiceDateChange = (e) => this.setState({ invoiceDate: e.target.value });
  onInvoiceAmountChange = (e) =>
    this.setState({ invoiceAmount: e.target.value });
  onStatusChange = (e) => this.setState({ status: e.target.value });
  onFilterVendorChange = (e) =>
    this.setState({ filterVendorId: e.target.value });
  onFilterFromDateChange = (e) =>
    this.setState({ filterFromDate: e.target.value });
  onFilterToDateChange = (e) =>
    this.setState({ filterToDate: e.target.value });
  onFilterStatusChange = (e) =>
    this.setState({ filterStatus: e.target.value });

  onResetFilters = () => {
    this.setState({
      filterVendorId: "",
      filterFromDate: "",
      filterToDate: "",
      filterStatus: "",
    });
  };

  //  Export function
  onExport = (filteredInvoices) => {
    const data = filteredInvoices.map((inv, index) => {
      const vendor = this.state.vendors.find((v) => v.id === inv.vendor_id);

      return {
        "S.No": index + 1,
        "Vendor Name": vendor ? vendor.vendor_name : "",
        "Invoice Date": inv.invoice_date,
        "Invoice Amount": inv.invoice_amount,
        "Status": inv.status,
        "Balance Amount": inv.balance_amount,
        "Uploaded Date": inv.uploaded_date,
        "Invoice File URL": inv.invoice_file || "",
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "VendorInvoices");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "VendorInvoices.xlsx");
  };

  addInvoice = (e) => {
    e.preventDefault();
    const invoiceAmount = Number(this.state.invoiceAmount);
    // Validate invoice amount
    if (
      this.state.invoiceAmount === "" ||
      isNaN(invoiceAmount) ||
      invoiceAmount <= 0
    ) {
      alert("Invoice amount must be greater than 0.");
      return;
    }
    const requestBody = {
      vendor_id: this.state.selectedVendor,
      invoice_date: this.state.invoiceDate,
      invoice_amount: invoiceAmount,
      balance_amount: invoiceAmount,
      status: "NOTPAID",
      uploaded_date: new Date().toISOString().split("T")[0],
      store_id: storeFresh.storeId,
    };
    postClientDataResponse(
      clientHost + ADD_VENDOR_INVOICE,
      storeFresh.key,
      requestBody,
      async (onSuccessResponse) => {
        console.log("Invoice Saved:", onSuccessResponse);
        const invoiceId = onSuccessResponse?.data?.id;
        if (!invoiceId) {
          console.error("Invoice ID not received:", onSuccessResponse);
          return;
        }
        // Upload invoice file if selected
        if (this.state.invoiceFile) {
          await this.UploadFilebyId(
            invoiceId,
            this.state.invoiceFile,
            "Add"
          );
        }
        // Refresh invoices after save/upload
        this.getInvoices();
        // Refresh payments
        this.getPayments();
        // Clear form
        this.setState({
          selectedVendor: "",
          invoiceDate: "",
          invoiceAmount: "",
          status: "NOTPAID",
          invoiceFile: null,
        });
      },
      (onError) => {
        console.error("Invoice save error:", onError);
      }
    );
  };

  getInvoices = () => {
    const apiPath = new Uri(clientHost + GET_VENDOR_INVOICES)
      .addQueryParam("store_id", storeFresh.storeId);
    console.log("Refreshing invoices...");
    getResponseClient(
      apiPath,
      storeFresh.key,
      (onSuccessResponse) => {
        console.log("Fresh invoices from API:", onSuccessResponse.result);

        this.setState(
          {
            invoices: onSuccessResponse.result || [],
          },
          () => {
            console.log(
              "Invoice state after refresh:",
              this.state.invoices
            );
          }
        );
      },
      (onError) => {
        console.error("Get invoices error:", onError);
      }
    );
  };
  getVendors = () => {
    var apiPath = new Uri(clientHost + GET_VENDORS).addQueryParam(
      "store_id",
      storeFresh.storeId
    );

    getResponseClient(
      apiPath,
      storeFresh.key,
      (res) => {
        const vendors = (res.result || []).sort((a, b) => {
          const nameA = (a.vendor_name || "").trim();
          const nameB = (b.vendor_name || "").trim();
          const getType = (name) => {
            if (/^[a-zA-Z]/.test(name)) return 1; // A-Z
            if (/^[0-9]/.test(name)) return 2;     // 0-9
            return 3;                              // Special characters
          };
          const typeA = getType(nameA);
          const typeB = getType(nameB);
          // First: A-Z, then 0-9, then special characters
          if (typeA !== typeB) {
            return typeA - typeB;
          }
          // Sort within each category
          return nameA.localeCompare(nameB, undefined, {
            numeric: true,
            sensitivity: "base"
          });
        });
        this.setState({
          vendors: vendors
        });
      },
      (err) => console.log(err)
    );
  };
  getPayments = () => {
    var apiPath = new Uri(clientHost + GET_PAYMENTS)
      .addQueryParam("store_id", storeFresh.storeId);
    getResponseClient(
      apiPath,
      storeFresh.key,
      (res) => {
        this.setState({
          payments: res.result,
        });
      },
      (err) => console.log(err)
    );
  };

  deleteInvoice = (id) => {
    console.log("========== DELETE START ==========");
    console.log("Invoice ID received:", id);

    const apiPath = new Uri(
      clientHost + DELETE_VENDOR_INVOICE
    ).addQueryParam("id", id);

    console.log("Delete API:", apiPath);

    getResponseClient(
      apiPath,
      storeFresh.key,
      (response) => {
        console.log("DELETE SUCCESS:", response);

        this.getInvoices();
        this.getPayments();
      },
      (error) => {
        console.error("DELETE ERROR:", error);
      }
    );
  };

  updateInvoice = (invoice) => {
    // Get all payments for this invoice
    const invoicePayments = this.state.payments.filter(
      (payment) => Number(payment.invoice_id) === Number(invoice.invoice_id)
    );
    // Calculate total amount already paid
    const totalPaid = invoicePayments.reduce(
      (total, payment) => total + Number(payment.payment_amount || 0),
      0
    );
    // New invoice amount
    const newInvoiceAmount = Number(invoice.invoice_amount);
    console.log("Invoice ID:", invoice.invoice_id);
    console.log("New Invoice Amount:", newInvoiceAmount);
    console.log("Total Paid:", totalPaid);
    // Validate invoice amount
    if (
      invoice.invoice_amount === "" ||
      isNaN(newInvoiceAmount) ||
      newInvoiceAmount <= 0
    ) {
      alert("Invoice amount must be greater than 0.");
      return;
    }
    // Prevent reducing invoice amount below paid amount
    if (newInvoiceAmount < totalPaid) {
      alert(
        `Invoice amount cannot be less than the total paid amount.\n\n` +
        `Total Paid: ${totalPaid.toFixed(2)}\n` +
        `New Invoice Amount: ${newInvoiceAmount.toFixed(2)}`
      );
      return;
    }
    const newBalanceAmount = newInvoiceAmount - totalPaid;
    const formData = new FormData();
    formData.append("id", invoice.invoice_id);
    formData.append("vendor_id", invoice.vendor_id);
    formData.append("invoice_date", invoice.invoice_date);
    formData.append("invoice_amount", newInvoiceAmount);
    formData.append("balance_amount", newBalanceAmount);
    postClientDataResponse(
      clientHost + UPDATE_VENDOR_INVOICE,
      storeFresh.key,
      formData,
      async (onSuccessResponse) => {
        console.log("Invoice updated successfully:", onSuccessResponse);
        if (this.state.invoiceFile) {
          await this.UploadFilebyId(
            onSuccessResponse.data.id,
            this.state.invoiceFile,
            "Add"
          );
        }
        this.getInvoices();
        this.getPayments();
      },
      (onError) => {
        console.log("Update invoice error:", onError.message);
      }
    );
  };
  convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };
  UploadFilebyId = (id, file, type) => {
    let img = file
    const handleFileRead = async (event) => {
      const file = img;
      const base64 = await this.convertBase64(file);
      const requestBody = {
        id: id,
        image: base64,
      };
      postClientDataResponse(
        clientHost + UPDATE_INVOICE_BILL_IMAGE,
        storeFresh.key,
        requestBody,
        (onSuccessResponse) => {
          this.setState({
            invoiceFile: "",
            editedinvoiceFile: ""
          })
          //if(type === 'update'){
          // this.getTodayExpenses();
          //  this.getTodaysTotalCost();
          //}
          this.getInvoices();
        },
        (onError) => {
          console.log(onError.message);
        }
      );
    };
    if (img === '' || img === null || img === undefined) {
      console.log("No files Selected")
    } else {
      handleFileRead();
    }
  }
  sortVendors = (vendors = []) => {
    return [...vendors].sort((a, b) => {
      const nameA = (a.vendor_name || "").trim();
      const nameB = (b.vendor_name || "").trim();
      const getType = (name) => {
        if (/^[A-Za-z]/.test(name)) return 1;   // Alphabets
        if (/^[0-9]/.test(name)) return 2;      // Numbers
        return 3;                               // Special characters
      };
      const typeA = getType(nameA);
      const typeB = getType(nameB);
      // First: Alphabet → Number → Special
      if (typeA !== typeB) {
        return typeA - typeB;
      }
      // Within the same type: alphabetical/natural order
      return nameA.localeCompare(nameB, undefined, {
        numeric: true,
        sensitivity: "base",
      });
    });
  };

  render() {
    return (
      <VendorInvoiceComponent
        invoices={this.state.invoices}
        vendors={this.state.vendors}
        payments={this.state.payments}
        selectedVendor={this.state.selectedVendor}
        status={this.state.status}
        balance_amount={this.state.balance_amount}
        invoiceDate={this.state.invoiceDate}
        invoiceAmount={this.state.invoiceAmount}
        invoiceFile={this.state.invoiceFile}
        filterVendorId={this.state.filterVendorId}
        filterFromDate={this.state.filterFromDate}
        filterToDate={this.state.filterToDate}
        filterStatus={this.state.filterStatus}
        onVendorChange={this.onVendorChange}
        onInvoiceDateChange={this.onInvoiceDateChange}
        onInvoiceAmountChange={this.onInvoiceAmountChange}
        onStatusChange={this.onStatusChange}
        onInvoiceFileChange={this.onInvoiceFileChange}
        addInvoice={this.addInvoice}
        deleteInvoice={this.deleteInvoice}
        updateInvoice={this.updateInvoice}
        onFilterVendorChange={this.onFilterVendorChange}
        onFilterFromDateChange={this.onFilterFromDateChange}
        onFilterToDateChange={this.onFilterToDateChange}
        onFilterStatusChange={this.onFilterStatusChange}
        onResetFilters={this.onResetFilters}
        onExport={this.onExport}
      />
    );
  }
}

export default VendorInvoiceContainer;
